<template>
  <div>
    <ul data-v-a1201187="" class="tab-a">
      <li data-v-a1201187="" :class="[index == 1 ? 'active' : '']" @click="onClick(1)">{{ $t('_jl._wxhd') }}</li>
      <li data-v-a1201187="" :class="[index == 2 ? 'active' : '']" @click="onClick(2)">{{ $t('_jl._lsjl') }}</li>
    </ul>
    <div>
      <like-records v-if="index == 1"> </like-records>
      <history-records v-if="index == 2"> </history-records>
    </div>
  </div>
</template>

<script>
import LikeRecords from '@/components/record/LikeRecords.vue'
import HistoryRecords from '@/components/record/HistoryRecords.vue'
export default {
  name: 'recordVue',
  components: { LikeRecords, HistoryRecords },
  data() {
    return {
      index: 1
    }
  },
  created() {
    this.index = this.$route.query.i ? parseInt(this.$route.query.i) : 1
  },
  methods: {
    onClick(index) {
      this.index = index
    }
  }
}
</script>

<style></style>
